import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Users from './views/Users.vue'
import CreateAdmin from './views/CreateAdmin.vue'
import Applications from './views/Applications.vue'
import ApplicantDetails from './views/ApplicantDetails.vue'
import Trainers from './views/Trainers.vue'
import TrainerDetails from './views/TrainerDetails.vue'
import TrainerCreate from './views/TrainerCreate.vue'
import TrainerUpdate from './views/TrainerUpdate.vue'
import Login from './views/Login'
import ForgotPassword from './views/ForgotPassword'
import AcceptInvite from './views/AcceptInvite'

// add router to Vue instance
Vue.use(Router)

/**
 * Guards to use in the `beforeEach` parameter
 * @type {{authGuard: (function(*, *, *))}}
 */
const guards = {
  /**
   * This guard will be run before every route navigation
   * @param to
   * @param from
   * @param next
   */
  globalGuard: (to, from, next) => {
    // wait for Cognito auth session to load
    router.app.$cognito.cognitoAuthenticatedUser().then((auth) => {
      /*
      Auth Guard
       */
      if (to.matched.some(record => record.meta.authRequired) && !auth) {
        // if no auth, redirect to login
        next({ name: 'login' })
        return
      }
      next()
    })
  }
}

/**
 * Routes
 * @type {VueRouter}
 */
const emptyComponent = {
  // render a router-view element to load the children into
  render (c) { return c('router-view') }
}
const router = new Router({
  routes: [
    {
      // Auth required routes (nested into a group)
      path: '',
      component: emptyComponent,
      meta: { authRequired: true },
      children: [
        {
          path: '/',
          name: 'home',
          component: Home
        },
        {
          path: '/users',
          name: 'users',
          component: Users
        },
        {
          path: '/users/create-admin',
          name: 'createAdmin',
          component: CreateAdmin
        },
        {
          path: '/applications',
          name: 'applications',
          component: Applications
        },
        {
          path: '/applicant/:id',
          name: 'applicantDetails',
          component: ApplicantDetails
        },
        {
          path: '/trainers',
          name: 'trainers',
          component: Trainers
        },
        {
          path: '/trainers/update/:id',
          name: 'trainerUpdate',
          component: TrainerUpdate
        },
        {
          path: '/trainers/create',
          name: 'trainerCreate',
          component: TrainerCreate
        },
        {
          path: '/trainer/:id',
          name: 'trainerDetails',
          component: TrainerDetails
        }
      ]
    },
    {
      /*
      Public Routes (No Auth Required)
       */
      path: '',
      component: emptyComponent,
      meta: { authRequired: false },
      children: [
        {
          path: '/login',
          component: Login,
          name: 'login'
        },
        {
          path: '/login/forgot-password',
          component: ForgotPassword,
          name: 'login.forgotPassword'
        },
        {
          path: '/accept-invite/:token',
          component: AcceptInvite,
          name: 'acceptInvite'
        }
      ]
    }
  ]
})

/**
 * Auth Guard
 */
router.beforeEach(guards.globalGuard)

export default router
